/**
 * A2A Teacher Service
 * Wraps teacher operations using A2A client instead of direct Supabase calls
 */

import { A2AClient } from '../client.js';
import { getAuthToken } from '../authHelper.js';

// Initialize A2A client with default backend URL and authentication
const a2aClient = new A2AClient(
  process.env.REACT_APP_A2A_BACKEND_URL || process.env.REACT_APP_API_URL || 'https://a2amyclassai-server.appsokay.net',
  'myclass-client-teachers',
  {
    secretKey: process.env.REACT_APP_A2A_SECRET_KEY,
    enableLogging: process.env.NODE_ENV === 'development',
    getAuthToken: getAuthToken
  }
);

/**
 * A2A Teacher Service
 */
export const a2aTeacherService = {
  /**
   * Get teachers
   */
  async getTeachers(params) {
    const { tenantId, subject, page = 1, limit = 50 } = params;
    
    const result = await a2aClient.executeTask('list_teachers', {
      tenant_id: tenantId,
      subject,
      page,
      limit
    });

    return {
      success: result.success,
      data: result.teachers || [],
      pagination: result.pagination
    };
  },

  /**
   * Get teacher by ID
   */
  async getTeacherById(teacherId, tenantId) {
    const result = await a2aClient.executeTask('get_teacher', {
      tenant_id: tenantId,
      teacher_id: teacherId
    });

    return {
      success: result.success,
      data: result.teacher
    };
  },

  /**
   * Create teacher
   */
  async createTeacher(teacherData) {
    const result = await a2aClient.executeTask('create_teacher', {
      tenant_id: teacherData.tenant_id,
      teacher_data: teacherData
    });

    return {
      success: result.success,
      data: result.teacher
    };
  },

  /**
   * Update teacher
   */
  async updateTeacher(teacherId, tenantId, teacherData) {
    const result = await a2aClient.executeTask('update_teacher', {
      tenant_id: tenantId,
      teacher_id: teacherId,
      teacher_data: teacherData
    });

    return {
      success: result.success,
      data: result.teacher
    };
  },

  /**
   * Delete teacher
   */
  async deleteTeacher(teacherId, tenantId) {
    const result = await a2aClient.executeTask('delete_teacher', {
      tenant_id: tenantId,
      teacher_id: teacherId
    });

    return {
      success: result.success
    };
  },

  /**
   * Get teacher's classes
   */
  async getTeacherClasses(params) {
    const { teacher_id, tenant_id } = params;
    
    const result = await a2aClient.executeTask('get_teacher_classes', {
      tenant_id: tenant_id,
      teacher_id: teacher_id
    });

    return {
      success: result.success,
      data: result.classes || result.data || []
    };
  },

  /**
   * Get teacher's students
   */
  async getTeacherStudents(params) {
    const { teacher_id, class_id, tenant_id } = params;
    
    const result = await a2aClient.executeTask('get_teacher_students', {
      tenant_id: tenant_id,
      teacher_id: teacher_id,
      class_id: class_id || null
    });

    return {
      success: result.success,
      data: result.students || result.data || []
    };
  }
};

export default a2aTeacherService;

